import { all, takeLatest, put } from 'redux-saga/effects';

import { types, showChatStageModal } from '../redux/chatModal';
import { updateAnswerStage } from '../redux/answerStage';

function* updateStageAndShowModalFlow(action) {
  const { stage } = action.payload;
  yield put(showChatStageModal());
  yield put(updateAnswerStage(stage));
}

export default function* () {
  yield all([
    takeLatest(
      types.UPDATE_STAGE_AND_SHOW_CHAT_STAGE_MODAL,
      updateStageAndShowModalFlow
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/sagas/chatModal.js